import moment from "moment";

function str_len(v) {
  if (v.length > 4) {
    return v.slice(0, 4);
  } else {
    return v;
  }
}

function color_text(c) {
  if (c.end > 1000) {
    return c.start + "-";
  } else {
    return c.start + "-" + c.end;
  }
}

function time_f(t) {
  if (t) {
    return moment(t).format("HH:mm:ss");
  } else {
    return t;
  }
}

function play_sta(t) {
  if (t) {
    return moment(t).format("MM-DD HH:mm");
  } else {
    return "00:00";
  }
}

function time_from_now(t) {
  return moment(t).fromNow();
}

function timest_to_str(t, time_type) {
  if (!t) {
    return "- -";
  }
  var format = "YYYY-MM-DD 00:00:00";
  if (time_type == "min" || time_type == "real") {
    format = "YYYY-MM-DD HH:mm:00";
  }
  if (time_type == "hour") {
    format = "YYYY-MM-DD HH:00:00";
  }
  if (time_type == "month") {
    format = "YYYY-MM-01 00:00:00";
  }

  return moment(t).format(format);
}

function getWindDirectionDesc(degree) {
  if (degree) {
    let descs = ["北", "东北", "东", "东南", "南", "西南", "西", "西北"];
    let index = Math.floor((degree + 22.5) / 45) % 8;
    return descs[index];
  } else {
    return "";
  }
}

function data_filter(v) {
  if (v == -1) {
    return "- -";
  } else {
    return v;
  }
}

function lengthLimit(str, length) {
  if (!length) {
    return str;
  }
  if (str.length > length) {
    str = str.slice(0, length) + "..";
    return str;
  } else {
    return str;
  }
}
export {
  str_len,
  color_text,
  time_f,
  time_from_now,
  timest_to_str,
  play_sta,
  getWindDirectionDesc,
  data_filter,
  lengthLimit
};
